const apiUrls = require('../../constants/apiUrls');

const orderDetails = {
    key: 'orderDetails',
    method: 'GET',
    getApiUrl: (request) => {
        return `${apiUrls.WORKORDER_DETAIL_URL}?workOrderNumber[]=${request.workOrderNumber}`;
    },
    dependencies: [
        {
            key: 'schedulingSystemDetails',
            requestProps: [
                {
                    path: [
                        'details', 'serviceOrderInfoV2', 'serviceOrderId'
                    ],
                    propName: 'workOrderNumber'
                }
            ]
        }
    ]
};

export default orderDetails;


// WEBPACK FOOTER //
// ./src/store/order-details-config/orderDetails.js